/** Only the sandboxed preview changes; the email sent by the gateway stays untouched. */
export function previewTheme(html, mode) {
  return html.replace(/@media\s*\(\s*prefers-color-scheme:\s*dark\s*\)/gi,mode === 'dark'?'@media all':'@media not all')
    .replace('</head>',`<style>:root{color-scheme:${mode}!important}html,body,*,*::before,*::after{scrollbar-width:none!important;-ms-overflow-style:none!important}*::-webkit-scrollbar{display:none!important;width:0!important;height:0!important}</style></head>`);
}
